import AxiosConfig from '../utils/AxiosConfig';

// Los errores de negocio llegan como códigos (staff_not_found, last_active_admin...) y las pantallas los traducen
// (ver pages/admin/staff/staffText.js): por eso se apaga el aviso automático del cliente HTTP, que mostraría el código crudo.
const quiet = { skipSnackbar: true, skipGlobalErrorRedirect: true };

class CoreStaffService {
  async list() {
    const response = await AxiosConfig.get('/core/staff', quiet);
    return response.data.data;
  }

  async create({ firstName, lastName, email }) {
    const response = await AxiosConfig.post('/core/staff', { first_name: firstName, last_name: lastName, email }, quiet);
    return response.data.data;
  }

  async update(id, { firstName, lastName, email }) {
    const response = await AxiosConfig.patch(`/core/staff/${id}`, { first_name: firstName, last_name: lastName, email }, quiet);
    return response.data.data;
  }

  async deactivate(id) {
    const response = await AxiosConfig.post(`/core/staff/${id}/deactivate`, {}, quiet);
    return response.data.data;
  }

  async reactivate(id) {
    const response = await AxiosConfig.post(`/core/staff/${id}/reactivate`, {}, quiet);
    return response.data.data;
  }

  async sendPasswordReset(id) {
    const response = await AxiosConfig.post(`/core/staff/${id}/send-password-reset`, {}, quiet);
    return response.data.data;
  }

  async remove(id) {
    const response = await AxiosConfig.delete(`/core/staff/${id}`, quiet);
    return response.data.data;
  }

  async audit({ limit = 100, targetId } = {}) {
    const response = await AxiosConfig.get('/core/staff/audit', { ...quiet, params: { limit, targetId } });
    return response.data.data;
  }

  // Pantalla pública: se llama sin sesión, con el link que llegó por mail.
  async validateSetupToken(token) {
    const response = await AxiosConfig.post('/core/staff-setup/validate', { token }, quiet);
    return response.data.data;
  }

  async completeSetup(token, newPassword) {
    const response = await AxiosConfig.post('/core/staff-setup/complete', { token, new_password: newPassword }, quiet);
    return response.data.data;
  }
}

export default new CoreStaffService();
